import { render, staticRenderFns } from "./AddBox.vue?vue&type=template&id=0e1f063c"
import script from "./AddBox.vue?vue&type=script&lang=js"
export * from "./AddBox.vue?vue&type=script&lang=js"
import style0 from "./AddBox.vue?vue&type=style&index=0&id=0e1f063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports